import React, { useEffect, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Grid, Skeleton } from '@sunwisesoftware/sunwise-ui';
import isNull from 'lodash/isNull';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import IconPreviewItem from 'common/components/IconPreviewItem';
import { useBreakpoint } from 'common/hooks';

import * as selectors from '../../selectors';

const DefaultTemplatesTab = ({
    categorySelected,
    handleSelectPage,
    isFetchingCustomTemplate,
    pageSelected,
    selectCategory,
}) => {
    const breakpoint = useBreakpoint();
    const [items, setItems] = useState(6);

    useEffect(() => {
        if (['xs', 'sm'].includes(breakpoint)) setItems(2);
        if (['md'].includes(breakpoint)) setItems(3);
        setItems(6);
    }, [breakpoint]);
    if (isFetchingCustomTemplate)
        return (
            <Grid container mb={2}>
                {Array.from(new Array(items)).map(() => (
                    <Grid
                        size={{ lg: 3, md: 9, xs: 9 }}
                        key={`skeleton-${Math.random()}`}
                    >
                        <Skeleton height={218} variant="rounded" />
                    </Grid>
                ))}
            </Grid>
        );
    if (isNull(categorySelected)) {
        return (
            <Grid container>
                <Grid size={{ lg: 3, md: 9, xs: 18 }}>
                    <IconPreviewItem
                        onClick={() =>
                            handleSelectPage({ id: 'blank-page', pages: 1 })
                        }
                        icon={<AddIcon fontSize="large" />}
                        isSelected={
                            pageSelected !== null &&
                            pageSelected.id === 'blank-page'
                        }
                        text="Plantilla en blanco"
                    />
                </Grid>
            </Grid>
        );
    }
    return (
        <Grid container>
            <Grid size={{ xs: 18, md: 9, lg: 3 }}>
                <IconPreviewItem
                    onClick={() => selectCategory(null)}
                    icon={<ArrowBackIosNewIcon fontSize="large" />}
                    text="Atras"
                />
            </Grid>
        </Grid>
    );
};

const mapStateToProps = createStructuredSelector({
    isFetchingCustomTemplate: selectors.getIsFetchingCustomTemplate,
});

DefaultTemplatesTab.propTypes = {
    categorySelected: PropTypes.string,
    handleSelectPage: PropTypes.func,
    isFetchingCustomTemplate: PropTypes.bool,
    pageSelected: PropTypes.object,
    selectCategory: PropTypes.func,
};

export default connect(mapStateToProps, null)(DefaultTemplatesTab);
